import { Link } from 'react-router-dom';

/**
 * Displays a list of informations about a winner.
 *
 * @description
 * A component that displays information about a winner from a campaign.
 * It displays the coupon code, invoice code, invoice date, invoice value and
 * customer name, linking to the invoice and customer pages.
 *
 * @param {Object} props - The props for the winner info component.
 * @param {Object} props.winner Object with the winner informations.
 *
 * @return {JSX.Element} The winner info component
 */
const WinnerInfo = ({ winner }) => {
  return (
    <>
      {[
        {
          label: 'Cupão:',
          value: winner?.coupon?.ROWID,
        },
        {
          label: 'Fatura:',
          value: winner?.invoice?.code,
          link: `/backoffice/invoices/${winner?.invoice?.ROWID}`,
        },
        {
          label: 'Cliente:',
          value: `${winner?.customer?.firstName} ${winner?.customer?.lastName}`,
          link: `/backoffice/customers/${winner?.customer?.ROWID}`,
        },
        {
          label: 'Cliente - Nº de Identificação:',
          value: `${winner?.customer?.cc}`,
        },
      ].map((item, i) => (
        <div className="flex items-center gap-2" key={i}>
          <span className="font-semibold">{item.label}</span>
          {item.link ? (
            <Link target="_blank" className="underline" to={item.link}>
              {item.value}
            </Link>
          ) : (
            <span>{item.value}</span>
          )}
        </div>
      ))}
    </>
  );
};

export default WinnerInfo;
